export const validPassword = /^(?=.*[0-9])(?=.*[!@#$%^&_*])[a-zA-Z0-9.!@#$%^&_*]{8,}$/;

export default function isValidLogoFormat(filename) {
    const pattern = /.*\.png|.jpg|.jpeg|.gif$/;
    return pattern.test(filename);
}

export const validWebsite = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export const validEmail = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;